import { SquarePen } from "lucide-react";
import styles from "./EntityCard.module.css";
import TagSubtitle from "../TagSubtitle"

function EntityCard({ title, subtitle, icon, verDetalhes, thisEntity }) {

    return (
        <div className={styles.container}>
            <div className={styles.containerInfo}>
                <div className={styles.containerIcon}>
                    {icon}
                </div>
                <div className={styles.infos}>
                    <h2 className={styles.title}>{title}</h2>
                    <TagSubtitle
                        text={subtitle}
                        color="#6a7181"
                    />
                </div>
            </div>
            <div className={styles.btn}>
                <SquarePen size={18} color="#1d121b" onClick={() => verDetalhes(thisEntity)} />
            </div>
        </div>
    )
}

export default EntityCard;